(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyersController', FlyersController);

    function FlyersController(Principal, Constants, $scope, $translate, $localStorage, $state, FlyersService,
                              FlyerCategoryService, toastr, $timeout, ModalFactory, ModalBrandFactory, paginationConstants,
                              StoreService, $stateParams, BrandService, ShowcasesService, StoreTypeService,
                              ErpsSettingsService, OnlineRetailService, BlingService, NexaasService, $uibModal, $window,
                              $rootScope, flyersConstants, MODAL_CONTENT_TYPES, ShowcaseSettingsService) {

        var vm = this;

        vm.$onInit = init;

        var storeId = $localStorage.defaultStore.storeId;
        var userId = $localStorage.userId;
        var listFilterLocalStorageKey = 'listFilter_' + userId + '_' + storeId;
        var filterLocalStorageKey = 'filter_' + userId + '_' + storeId;
        var isListViewLocalStorageKey = 'isListView_' + userId + '_' + storeId;
        var groupByColorLocalStorageKey = 'groupByColor_' + userId + '_' + storeId;
        var WITH_STOCK = 'WITH_STOCK';
        var OUT_OF_STOCK = 'OUT_OF_STOCK';
        var STORE_PAGE_DEFAULT = 0;
        var STORE_SIZE_DEFAULT = 25;

        var ERP_ICON_MAP = {
            11: {
                color: "#411D5A",
                iconClass: "erp-variation-icon icon-ksc-setadigital-solid"
            },
            10: {
                color: "#89bf04",
                iconClass: "erp-variation-icon icon-ksc-icon-bling-solid"
            },
            9: {
                color: "#da3063",
                iconClass: "erp-variation-icon icon-ksc-icon-nexaas-solid"
            },
            8: {
                color: "#00806e",
                iconClass: "erp-variation-icon icon-ksc-icon-varejo-online-solid"
            }
        };

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.time_stamp_to_image = '';
        vm.selectedFlyers = [];

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };
        vm.configuration = {};

        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isHubContext = $localStorage.defaultStore.hubContext;

        function init() {
            var locale = $translate.use().toLowerCase();

            vm.sortOptions = getSortOptions(locale);

            loadStore();
            updateIsMobile();
            configureFlyerMethods();
            initializeActionsOptions();
            initializeMassSelectionActionsOptions();
            getConfigurationsValues();

            vm.listFilter.sortBy = 'lastModifiedDate';
            vm.listFilter.sortDirection = 'desc';
            loadAll();
        }

        angular.element($window).on('resize', function () {
            $scope.$apply(updateIsMobile);
        });

        vm.flyersFiltered = [];
        vm.flyersTypes = [];
        vm.zeroOffers = false;
        vm.startDate = {
            startDate: null,
            endDate: null
        };
        vm.isLoading = true;
        vm.listFlyers = true;
        vm.loadingArray = ["1", "2", "3", "4"];

        vm.isListView = $localStorage[isListViewLocalStorageKey] === undefined ? true : $localStorage[isListViewLocalStorageKey];
        vm.groupByColor = $localStorage[groupByColorLocalStorageKey] === undefined ? false : $localStorage[groupByColorLocalStorageKey];

        vm.listFilter = $localStorage[listFilterLocalStorageKey] || {
            activated: null,
            hasInventory: false,
            storeId: $localStorage.defaultStore.storeId,
            sortBy: 'lastModifiedDate',
            sortDirection: 'desc',
        };

        vm.listFilter.storeId = $localStorage.defaultStore.storeId;

        vm.filters = $localStorage[filterLocalStorageKey] || {
            region: [],
            categories: [],
            brands: [],
            hubSyncFilter: null,
            colors: [],
            sizes: [],
            genders: [],
            bedrooms: [],
            bathrooms: [],
            parkingSpots: [],
            configurations: [],
            hasInventory: true,
            minValue: null,
            maxValue: null,
            minMeters: null,
            maxMeters: null,
            sinceDate: null,
            untilDate: null,
            sortSelected: {
                value: 'lastModifiedDate',
                direction: 'desc',
            },
        };

        vm.userIsAdmin = false;

        vm.flyersToRemove = [];
        vm.page = 0;
        vm.hasNextPage = false;
        vm.busy = false;
        vm.brands = [];
        vm.brandGroups = {};
        vm.colors = [];
        vm.categoryGroups = {};
        vm.numberFilterSelected = 0;


        vm.stores = [];
        vm.storesSelected = [];
        vm.storeTypes = [];
        vm.storeName = '';

        vm.requestParamsStore = {
            page: STORE_PAGE_DEFAULT,
            size: STORE_SIZE_DEFAULT
        }

        StoreTypeService.getAllStoreTypesByOwner().then(function (response) {
            vm.storeTypes = response.data;
        });

        vm.selectedSortByOption = "lastModifiedDate";

        vm.flyerMethods = new Map();

        function loadStores(pageOptions) {
            vm.isStoresAvailable = false;

            StoreService.listStoresByCurrentHub({}, pageOptions, function (data, headers) {
                vm.stores = data;
                vm.isStoresAvailable = true;
            }, function (error) {
                vm.isStoresAvailable = true;
            });
        }

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        vm.loadingActionRequest = false;
        vm.erpProductsCount = 0;

        function initializeActionsOptions() {
            vm.selectedActions = [
                {
                    value: 'REMOVE',
                    translation: vm.getTranslateKey('flyers.selection-actions.remove'),
                    actionFunc: function () {
                        return vm.verifyIfFlyersIsPublished();
                    }
                }
            ];

            if (!vm.isImmoContext) {
                vm.selectedActions.push(
                    {
                        value: 'CLEAR_STOCK',
                        translation: 'flyers.selection-actions.clear-stock',
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.clear-stock-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.clear-stock-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.clear-stock-modal.small-text'),
                                null,
                                $translate.instant('flyers.selection-actions.modals.clear-stock-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.clearStock
                            );
                        }
                    },
                    {
                        value: 'APPLY_DISCOUNTS',
                        translation: 'flyers.selection-actions.apply-discounts',
                        actionFunc: function () {
                            ModalFactory.openDiscountModal($translate.instant('flyers.selection-actions.modals.discount-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.subtitle'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.input-label'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.input-footer'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                applyDiscounts
                            );
                        }
                    },
                    {
                        value: 'SYNC_ERP',
                        translation: 'flyers.selection-actions.sync-with-erp',
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.sync-erp-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.sync-erp-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.sync-erp-modal.small-text'),
                                $translate.instant('flyers.selection-actions.modals.sync-erp-modal.warning-text'),
                                $translate.instant('flyers.selection-actions.modals.sync-erp-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.syncronizeProducts
                            );
                        }
                    },
                    {
                        value: 'UNPUBLISH',
                        translation: vm.getTranslateKey('flyers.selection-actions.unpublish'),
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.unpublish-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.unpublish-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.unpublish-modal.small-text'),
                                null,
                                $translate.instant('flyers.selection-actions.modals.unpublish-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.unpublishFlyers
                            );
                        }
                    },
                    {
                        value: 'PUBLISH',
                        translation: vm.getTranslateKey('flyers.selection-actions.publish'),
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.publish-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.publish-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.publish-modal.small-text'),
                                null,
                                $translate.instant('flyers.selection-actions.modals.publish-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.publishFlyers
                            );
                        }
                    },
                    {
                        value: 'SYNC_IMAGE_FLYERS',
                        translation: 'flyers.selection-actions.sync-flyers-with-hub',
                        actionFunc: function () {
                            ModalFactory.openSyncWithHubModal($translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.small-text'),
                                null,
                                [
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-name',
                                        value: false,
                                        syncParam: "SYNC_PARAM_NAME"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-description',
                                        value: false,
                                        syncParam: "SYNC_PARAM_DESCRIPTION"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-image',
                                        value: false,
                                        syncParam: "SYNC_PARAM_IMAGE"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-category',
                                        value: false,
                                        syncParam: "SYNC_PARAM_CATEGORY"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-brand',
                                        value: false,
                                        syncParam: "SYNC_PARAM_BRAND"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-tag',
                                        value: false,
                                        syncParam: "SYNC_PARAM_TAGS"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-video',
                                        value: false,
                                        syncParam: "SYNC_PARAM_VIDEO"
                                    }
                                ],
                                $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.syncronizeProductsWithHub
                            );
                        }
                    });
            } else {
                vm.selectedActions.push(
                    {
                        value: 'UNPUBLISH',
                        translation: vm.getTranslateKey('flyers.selection-actions.unpublish'),
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.unpublish-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.unpublish-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.unpublish-modal.small-text'),
                                null,
                                $translate.instant('flyers.selection-actions.modals.unpublish-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.unpublishFlyers
                            );
                        }
                    },
                    {
                        value: 'PUBLISH',
                        translation: vm.getTranslateKey('flyers.selection-actions.publish'),
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.publish-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.publish-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.publish-modal.small-text'),
                                null,
                                $translate.instant('flyers.selection-actions.modals.publish-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.publishFlyers
                            );
                        }
                    },
                    {
                        value: 'SYNC_IMAGE_FLYERS',
                        translation: 'flyers.selection-actions.sync-flyers-with-hub',
                        actionFunc: function () {
                            ModalFactory.openSyncWithHubModal($translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.small-text'),
                                null,
                                [
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-name',
                                        value: false,
                                        syncParam: "SYNC_PARAM_NAME"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-description',
                                        value: false,
                                        syncParam: "SYNC_PARAM_DESCRIPTION"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-image',
                                        value: false,
                                        syncParam: "SYNC_PARAM_IMAGE"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-category',
                                        value: false,
                                        syncParam: "SYNC_PARAM_CATEGORY"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-brand-immo',
                                        value: false,
                                        syncParam: "SYNC_PARAM_BRAND"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-tag',
                                        value: false,
                                        syncParam: "SYNC_PARAM_TAGS"
                                    },
                                    {
                                        translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-video',
                                        value: false,
                                        syncParam: "SYNC_PARAM_VIDEO"
                                    }
                                ],
                                $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.syncronizeProductsWithHub
                            );
                        }
                    });
            }

            vm.flyerActionsCache = {};

            vm.flyerActions = [
                {
                    name: flyersConstants.FLYER_ACTION.SEND,
                    icon: "icon-ksc-share-on-whatsapp-solid whatsapp-green",
                    shortLabel: "flyers.actions.send-short",
                    label: 'flyers.actions.send',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.SEND)
                },
                {
                    name: flyersConstants.FLYER_ACTION.LINK,
                    icon: "icon-ksc-link-right-light",
                    shortLabel: "flyers.actions.copyLink-short",
                    label: 'flyers.actions.copyLink',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.LINK)
                },
                {
                    name: flyersConstants.FLYER_ACTION.HOTSITE,
                    icon: "icon-ksc-up-right-from-square-light",
                    shortLabel: "flyers.actions.hotsite-short",
                    label: 'flyers.actions.hotsite',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.HOTSITE)
                },
                {
                    name: flyersConstants.FLYER_ACTION.EDIT,
                    icon: "icon-ksc-pen-to-square-light",
                    label: 'flyers.actions.edit',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.EDIT)
                },
                {
                    name: flyersConstants.FLYER_ACTION.DELETE,
                    icon: "icon-ksc-trash-light",
                    label: 'flyers.actions.delete',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.DELETE)
                },
                {
                    name: flyersConstants.FLYER_ACTION.DUPLICATE,
                    icon: "icon-ksc-clone-light",
                    label: 'flyers.actions.duplicate',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.DUPLICATE),
                    hidden: function () {
                        return true;
                    }
                },
                {
                    name: flyersConstants.FLYER_ACTION.RECOMMEND,
                    icon: "fa fa-star",
                    label: 'flyers.actions.recommend',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.RECOMMEND),
                    hidden: function () {
                        return true;
                    }
                },
                {
                    name: flyersConstants.FLYER_ACTION.UNPUBLISH,
                    icon: "icon-ksc-arrow-down-light",
                    label: 'flyers.actions.unpublishFlyer',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.UNPUBLISH),
                    hidden: function (flyer) {
                        return !vm.checkFlyerIsPublished(flyer);
                    }
                },
                {
                    name: flyersConstants.FLYER_ACTION.PUBLISH,
                    icon: "icon-ksc-arrow-up-light",
                    label: 'flyers.actions.publishFlyer',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.PUBLISH),
                    hidden: function (flyer) {
                        return vm.checkFlyerIsPublished(flyer);
                    }
                }
            ];

            vm.moreActions = [
                {
                    name: 'importFlyer',
                    icon: "fa fa-cloud-upload",
                    label: vm.getTranslateKey('flyers.import.subtitle'),
                    method: vm.goToImport
                }
            ];

            if (vm.isMobile || !vm.isImmoContext) {
                vm.moreActions.splice(1, 0, {
                    name: 'importFlyerFromHub',
                    icon: "fa fa-arrow-up",
                    label: vm.getTranslateKey('flyers.import-hub.btn'),
                    method: vm.goToImportHub
                });
            }

            vm.selectedActions.push();
        }

        vm.buildFlyerActions = function (flyer) {
            if (vm.flyerActionsCache[flyer.id]) {
                return vm.flyerActionsCache[flyer.id];
            }

            var actionNames = ['SEND', 'LINK', 'HOTSITE', 'EDIT', 'DELETE', 'DUPLICATE', 'RECOMMEND', 'UNPUBLISH', 'PUBLISH'];

            var actions = actionNames.map(function (name) {
                var baseAction = vm.flyerActions.find(function (a) {
                    return a.name === name;
                });

                if (!baseAction) return null;

                return {
                    name: baseAction.name,
                    label: baseAction.label,
                    shortLabel: baseAction.shortLabel,
                    icon: baseAction.icon,
                    url: getFlyerUrl(flyer),
                    hidden: typeof baseAction.hidden === 'function' ? function () {
                        return baseAction.hidden(flyer);
                    } : baseAction.hidden,
                    method: typeof baseAction.method === 'function' ? function () {
                        return baseAction.method(flyer);
                    } : baseAction.method
                };
            }).filter(function (item) {
                return item !== null;
            });

            vm.flyerActionsCache[flyer.id] = actions;
            return actions;
        };

        function initializeMassSelectionActionsOptions() {
            vm.selectionTypes = [
                {
                    value: 'ALL',
                    translation: 'flyers.selection-filters.all'
                },
                {
                    value: 'ALL_FROM_PAGE',
                    translation: 'flyers.selection-filters.select-all-from-page'
                },
                {
                    value: 'PUBLISHED',
                    translation: 'flyers.selection-filters.published'
                },
                {
                    value: 'UNPUBLISHED',
                    translation: 'flyers.selection-filters.unpublished'
                },
                {
                    value: 'OUT_OF_STOCK',
                    translation: 'flyers.selection-filters.out-of-stock'
                },
                {
                    value: 'WITH_STOCK',
                    translation: 'flyers.selection-filters.with-stock'
                },
                {
                    value: 'NONE',
                    translation: 'flyers.selection-filters.select-none'
                }
            ];
        }

        vm.getSelectionTypes = function () {
            if (vm.isImmoContext) {
                return vm.selectionTypes.filter(function (type) {
                    return type.value !== WITH_STOCK && type.value !== OUT_OF_STOCK;
                });
            }
            return vm.selectionTypes;
        };

        vm.selectionTypesData = {
            currentSelection: 'NONE',
            'ALL': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllFromStore();
                }
            },
            'ALL_FROM_PAGE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllItems();
                }
            },
            'PUBLISHED': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllPublished();
                }
            },
            'UNPUBLISHED': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllUnpublished();
                }
            },
            'OUT_OF_STOCK': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllOutOfStock();
                }
            },
            'WITH_STOCK': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllWithStock();
                }
            },
            'NONE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.unselectAll();
                }
            }
        };

        vm.onSelectedSortOption = function (newValue) {
            clearPaginationInfo();
            vm.selectedSortByOption = newValue;
            vm.listFilter.sortBy = vm.selectedSortByOption.value;
            vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
            loadFlyers();
        }

        checkUserIsAdmin();

        vm.loadFlyers = loadFlyers;

        vm.randomTime = new Date().getTime();

        function clearPaginationInfo() {
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        function checkUserIsAdmin() {
            Principal.hasAuthority("ADMIN_MANAGE_SYSTEM").then(function (result) {
                if (result) {
                    vm.userIsAdmin = true;
                } else {
                    vm.userIsAdmin = false;
                }
            });
        }

        vm.searchForTerm = function () {
            clearPaginationInfo();
            vm.loadFlyers();
        }

        vm.changeDisplayType = function () {
            vm.isListView = !vm.isListView;
            $localStorage[isListViewLocalStorageKey] = vm.isListView;
        };

        vm.changeActivated = function () {
            vm.page = 0;
            if (vm.listFilter.activated === null) {
                vm.listFilter.activated = true;
            } else {
                vm.listFilter.activated = !vm.listFilter.activated;
            }
            loadFlyers();
        };

        vm.openCalendarStart = function (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarStart = true;
        };

        vm.openCalendarExpire = function (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarExpire = true;
        };

        vm.flyerDetailPage = function (flyerId) {
            $state.go('flyers.edit', {
                id: flyerId
            });
        };

        vm.goToImportHub = function () {
            if (vm.isImmoContext) {
                $state.go('flyers.import-hub.select-flyers');
            } else {
                $state.go('flyers.import-hub');
            }
        };

        vm.goToImport = function () {
            $state.go('flyers.import');
        };

        vm.flyerDetailModal = function (flyerId) {
            var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                return flyer.id === flyerId;
            });
            var flyerActions = vm.buildFlyerActions(flyerSelected);

            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/flyers/flyer-detail/flyer-detail-modal.html',
                controller: 'FlyerDetailsController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal',
                windowTopClass: 'flyer-detail-modal full-bleed',
                size: 'double-panel',
                backdrop: 'static',
                resolve: {
                    flyerId: function () {
                        return flyerId;
                    },
                    isHubContext: function () {
                        return vm.isHubContext;
                    },
                    isImmoContext: function () {
                        return vm.isImmoContext;
                    },
                    menuActions: function () {
                        var modalActionsNames = ['EDIT', 'DELETE', 'DUPLICATE', 'RECOMMEND', 'PUBLISH', 'UNPUBLISH'];
                        var modalActions = [];
                        modalActionsNames.forEach(function (modalActionName) {
                            var modalAction = flyerActions.find(function (action) {
                                return action.name === modalActionName;
                            });
                            modalActions.push(modalAction);
                        });
                        return modalActions;
                    },
                    quickActions: function () {
                        var quickActionsNames = ['HOTSITE', 'LINK', 'SEND'];
                        var quickActions = [];
                        quickActionsNames.forEach(function (quickActionName) {
                            var quickAction = flyerActions.find(function (action) {
                                return action.name === quickActionName;
                            });
                            quickActions.push(quickAction);
                        });
                        return quickActions;
                    }
                }
            });

            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.CLOSE_DETAILS_MODAL,
                function (actionName) {
                    modalInstance.dismiss(actionName);
                }
            );

            return modalInstance;
        }

        vm.verifyIfFlyersIsPublished = function () {
            var closeModal = vm.flyerMethods.get(flyersConstants.FLYER_ACTION.CLOSE_DETAILS_MODAL);
            if (typeof closeModal === 'function') {
                closeModal(flyersConstants.FLYER_ACTION.EDIT);
            }

            if(vm.singleFlyerToDelete) {
                FlyersService.verifyIfFlyersIsPublished([vm.singleFlyerToDelete]).then(function () {
                    ModalFactory.openWarningModal(
                        $translate.instant('flyers.selection-actions.modals.remove-modal.title'),
                        $translate.instant(vm.getTranslateKey('flyers.selection-actions.modals.remove-modal.subtitle-single-removal')),
                        $translate.instant('flyers.selection-actions.modals.remove-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.remove-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.removeFlyers
                    );
                }, function (response) {
                    ModalFactory.openWarningModal(
                        $translate.instant('flyers.selection-actions.modals.remove-published-modal.title'),
                        $translate.instant(vm.getTranslateKey('flyers.selection-actions.modals.remove-published-modal.subtitle-single-removal-published')),
                        $translate.instant('flyers.selection-actions.modals.remove-published-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.remove-published-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.removeFlyers
                    );
                });
            }else {
                FlyersService.verifyIfFlyersIsPublished(vm.selectedFlyers).then(function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.remove-modal.title'),
                        $translate.instant(vm.getTranslateKey('flyers.selection-actions.modals.remove-modal.subtitle'), {amount: vm.selectedFlyers.length}),
                        $translate.instant('flyers.selection-actions.modals.remove-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.remove-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.removeFlyers
                    );
                }, function (response) {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.remove-published-modal.title'),
                        $translate.instant(vm.getTranslateKey('flyers.selection-actions.modals.remove-published-modal.subtitle'),
                            {amount: response.data.data.amount, amountPublished: response.data.data.publishedAmount}),
                        $translate.instant('flyers.selection-actions.modals.remove-published-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.remove-published-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.removeFlyers
                    );
                });
            }
        }

        vm.removeFlyers = function () {
            if(vm.singleFlyerToDelete) {
                vm.removalLoading = true;
                vm.loadingActionRequest = true;
                FlyersService.deleteFlyers([vm.singleFlyerToDelete]).then(function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.remove.success'));
                    vm.selectedFlyers = [];
                    $state.reload();
                }, function (data) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    if (data.data.message.includes('errorShowcase')) {
                        toastr.error($translate.instant('flyers.messages.remove.errorShowcase'));
                    } else {
                        toastr.error($translate.instant('flyers.messages.remove.error'));
                    }
                });
                vm.singleFlyerToDelete = null;
            } else {
                if (vm.existsSelectedItems()) {
                    vm.removalLoading = true;
                    vm.loadingActionRequest = true;
                    FlyersService.deleteFlyers(vm.selectedFlyers).then(function (data) {
                        vm.removalLoading = false;
                        vm.loadingActionRequest = false;
                        toastr.success($translate.instant('flyers.messages.remove.success'));
                        vm.selectedFlyers = [];
                        $state.reload();
                    }, function (data) {
                        vm.removalLoading = false;
                        vm.loadingActionRequest = false;
                        if (data.data.message.includes('errorShowcase')) {
                            toastr.error($translate.instant('flyers.messages.remove.errorShowcase'));
                        } else {
                            toastr.error($translate.instant('flyers.messages.remove.error'));
                        }
                    });
                } else {
                    toastr.error($translate.instant('flyers.messages.remove.noItens'));
                }
            }
        };

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function (el) {
                return el.key === flyer.categoryKey
            });
            if (category) {
                flyer.category = category.title;
            }
        }

        function loadAll() {
            vm.time_stamp_to_image = '?' + Date.now();
            loadErpConfiguration();
            loadBrandsAndCategories();
            getFlyersTypes();
            getCategories();
            vm.requestParamsStore.name = vm.storeName;
            loadStores(vm.requestParamsStore);

            ShowcasesService.getAllFlyerIdsFromShowcasesPublished().then(function (data) {
                vm.publishedProducts = data;
            });

            if ($stateParams.type) {
                // Changes the type to the new type Clicked
                vm.listFilter.type = $stateParams.type;

                // Erases the offer list
                vm.flyersFiltered = [];

                // Turn to 0 the page to give right page on pageable
                vm.page = 0;
            }

            FlyersService.getAllFiltersFlyer().then(function (response) {
                vm.colors = response.data.colors;
                vm.sizes = response.data.sizes;
            });
        }

        function getCategories() {
            if (!vm.categories || !vm.categories.length) {
                FlyerCategoryService.listCategoriesByCurrentStore($translate.use()).then(function (response) {
                    vm.categories = response.data.filter(function (category) {
                        return category.countFlyer > 0;
                    });
                    vm.categories = _.uniqBy(vm.categories, 'key');
                    vm.categories.forEach(function (category) {
                        vm.categoryGroups[category.key] = {
                            count: 0,
                            total: category.countFlyer
                        };
                    });
                    sortCategoriesByName();
                });
            } else {
                loadFlyers();
            }
        }

        function getBrands() {
            if (!vm.brands || !vm.brands.length) {
                BrandService.getBrandsByCurrentStore().then(function (response) {
                    vm.brands = response.data.filter(function (brand) {
                        return brand.quantFlyer > 0;
                    });
                    vm.brands = _.uniqBy(vm.brands, 'name');
                    sortBrandsByName();
                    vm.brands.forEach(function (brand) {
                        vm.brandGroups[brand.name] = {
                            count: 0,
                            total: brand.quantFlyer
                        };
                    });
                    loadFlyers();
                });
            } else {
                loadFlyers();
            }
        }

        function getFlyersTypes() {
            FlyersService.getFlyerTypes().then(function (response) {
                var removeRent = response.data.map(function (item) {
                    return item.code;
                }).indexOf('RENT');
                response.data.splice(removeRent, 1);
                var removeContact = response.data.map(function (item) {
                    return item.code;
                }).indexOf('CONTACT');
                response.data.splice(removeContact, 1);
                vm.flyersTypes = response.data;
            });
        }

        function loadErpConfiguration() {
            ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                .then(function (response) {
                    if (response.data && response.data.id) {
                        vm.configuration = response.data;
                    }
                    vm.erpIcon = ERP_ICON_MAP[vm.configuration.partnerId] || null;
                });
        }

        function loadBrandsAndCategories() {
            setTimeout(function () {
                //load default filter
                getCategories();
                getBrands();

            }, 1000);
        }

        function sortCategoriesByName() {
            vm.categories = vm.categories.sort(function (a, b) {
                if (a.title.toLowerCase() < b.title.toLowerCase()) {
                    return -1;
                }
                if (a.title.toLowerCase() > b.title.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        function sortBrandsByName(){
            vm.brands = vm.brands.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase()) {
                    return -1;
                }
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        function getFlyerKey(flyer) {
            if (vm.groupByColor && flyer.groupingColorId) {
                return flyer.id + '_' + flyer.groupingColorId;
            }
            return flyer.id;
        }

        vm.refreshSelectedFlyers = function (flyer) {
            var key = getFlyerKey(flyer);

            vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] || { count: 0 };
            vm.categoryGroups[flyer.categoryKey] = vm.categoryGroups[flyer.categoryKey] || { count: 0 };

            if (flyer.isSelected) {
                vm.brandGroups[flyer.brand].count--;
                vm.categoryGroups[flyer.categoryKey].count--;
                flyer.isSelected = false;
                delete vm.selectedVisualKeys[key];
            } else {
                vm.brandGroups[flyer.brand].count++;
                vm.categoryGroups[flyer.categoryKey].count++;
                flyer.isSelected = true;
                vm.selectedVisualKeys[key] = true;
            }

            updateSelectedFlyersFromVisualKeys();
        };

        function updateSelectedFlyersFromVisualKeys() {
            var ids = [];
            Object.keys(vm.selectedVisualKeys).forEach(function(k) {
                var idPart = k.split('_')[0];
                if (/^\d+$/.test(idPart)) {
                    ids.push(parseInt(idPart, 10));
                } else {
                    ids.push(idPart);
                }
            });
            vm.selectedFlyers = _.uniq(ids);
            vm.selectedAll = vm.isAllFromPageSelected();
        }

        vm.existsSelectedItems = function () {
            return vm.selectedFlyers.length >= 1;
        };

        vm.isIndeterminate = function () {
            var selectedCount = Object.keys(vm.selectedVisualKeys || {}).length;
            return selectedCount > 0 && selectedCount < vm.flyersFiltered.length;
        }

        vm.isAllFromPageSelected = function () {
            if (!vm.flyersFiltered || vm.flyersFiltered.length === 0) {
                return false;
            }
            return vm.flyersFiltered.every(function (flyer) {
                return vm.checkIfFlyerSelected(flyer);
            });
        }

        vm.getCountSelectedByBrand = function (brand) {
            return vm.brandGroups[brand].count;
        };

        vm.getCountSelectedByCategory = function (category) {
            return vm.categoryGroups[category].count;
        };

        vm.refreshFlyersSelected = function () {
            vm.makeBrandGroups();
        }

        vm.selectAllItems = function () {
            vm.selectedAll = !vm.isAllFromPageSelected();
            vm.selectedVisualKeys = vm.selectedVisualKeys || {};

            angular.forEach(vm.flyersFiltered, function (flyer) {
                var key = getFlyerKey(flyer);

                vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] || { count: 0 };
                vm.categoryGroups[flyer.categoryKey] = vm.categoryGroups[flyer.categoryKey] || { count: 0 };

                if (vm.selectedAll) {
                    if (!vm.selectedVisualKeys[key]) {
                        vm.brandGroups[flyer.brand].count++;
                        vm.categoryGroups[flyer.categoryKey].count++;
                        flyer.isSelected = true;
                        vm.selectedVisualKeys[key] = true;
                    }
                } else {
                    if (vm.selectedVisualKeys[key]) {
                        vm.brandGroups[flyer.brand].count--;
                        vm.categoryGroups[flyer.categoryKey].count--;
                        flyer.isSelected = false;
                        delete vm.selectedVisualKeys[key];
                    }
                }
            });
            updateSelectedFlyersFromVisualKeys();
        };

        vm.checkIfFlyerSelected = function (flyer) {
            vm.selectedVisualKeys = vm.selectedVisualKeys || {};
            return !!vm.selectedVisualKeys[getFlyerKey(flyer)];
        }

        vm.selectItemsBy = function (selectBy, isFromSelection) {
            isFromSelection = isFromSelection ? isFromSelection : false;
            if (selectBy === 'ALL_FROM_PAGE' && vm.isAllFromPageSelected() && !vm.isIndeterminate() && !isFromSelection) {
                vm.unselectAllFromPage();
                vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;
                vm.selectionTypesData.currentSelection = 'NONE'
                return;
            }

            if (isFromSelection && selectBy !== 'ALL_FROM_PAGE') {
                vm.unselectAll();
            }
            vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;

            vm.selectionTypesData[selectBy].selectFunc();

            vm.selectionTypesData.currentSelection = selectBy;
            vm.selectionTypesData[selectBy].isActivated = true;
        }

        vm.isErpIntegrated = function (flyer) {
            if (flyer.erpProductId) {
                return true;
            } else if (flyer.details && flyer.details.length) {
                for (var index in flyer.details) {
                    var detail = flyer.details[index];
                    if (detail.erpProductId) {
                        return true;
                    }
                }
            } else {
                return false;
            }
        }

        vm.showAction = function (action) {
            if (action.value === 'SYNC_ERP') {
                return vm.configuration && vm.configuration.id && vm.configuration.id != Constants.ErpPartnerId.SETA;
            }
            return true;
        }

        function setSelectedProductsByBrand(brandSet) {
            vm.brands.forEach(function (brand) {
                if (brandSet[brand.name]) {
                    var flyersId = brandSet[brand.name].map(function (product) {
                        var flyersSelected = vm.flyersFiltered.filter(function (flyer) {
                            return flyer.id === product.id;
                        });
                        flyersSelected.forEach(function(flyerSelected) {
                            flyerSelected.isSelected = true;
                            var key = getFlyerKey(flyerSelected);
                            vm.selectedVisualKeys[key] = true;
                        });
                        return product.id;
                    })
                    vm.selectedFlyers = vm.selectedFlyers.concat(flyersId);
                    vm.brandGroups[brand.name].count = brandSet[brand.name].length;
                }
            });
            vm.selectedFlyers = _.uniq(vm.selectedFlyers);
        }

        function setSelectedProductsByCategory(categorySet) {
            if (vm.isImmoContext) {
                var flyersId = Object.values(categorySet).flat().map(function (product) {
                    var flyersSelected = vm.flyersFiltered.filter(function (flyer) {
                        return flyer.id === product.id;
                    });
                    flyersSelected.forEach(function(flyerSelected) {
                        flyerSelected.isSelected = true;
                        var key = getFlyerKey(flyerSelected);
                        vm.selectedVisualKeys[key] = true;
                    });
                    return product.id;
                });
                vm.selectedFlyers = _.uniq(vm.selectedFlyers.concat(flyersId));
            } else {
                vm.categories.forEach(function (category) {
                    if (categorySet[category.key]) {
                        var flyersId = categorySet[category.key].map(function (product) {
                            var flyersSelected = vm.flyersFiltered.filter(function (flyer) {
                                return flyer.id === product.id;
                            });
                            flyersSelected.forEach(function(flyerSelected) {
                                flyerSelected.isSelected = true;
                                var key = getFlyerKey(flyerSelected);
                                vm.selectedVisualKeys[key] = true;
                            });
                            return product.id;
                        });

                        vm.selectedFlyers = vm.selectedFlyers.concat(flyersId);
                        vm.categoryGroups[category.key].count = categorySet[category.key].length;
                    }
                });
                vm.selectedFlyers = _.uniq(vm.selectedFlyers);
            }
        }

        vm.selectAllFromStore = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllPublished = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                isPublished: true
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllUnpublished = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                isPublished: false
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllWithStock = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                hasInventory: true
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllOutOfStock = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                hasNoInventory: true,
                brandSelected: !!vm.listFilter.brand
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.unselectAll = function () {
            vm.selectedFlyers = [];
            vm.selectedVisualKeys = {};
            if (vm.flyersFiltered) {
                vm.flyersFiltered.forEach(function (flyer) {
                    flyer.isSelected = false;
                });
            }
            vm.brands.forEach(function (brand) {
                vm.brandGroups[brand.name].count = 0;
            });
            vm.categories.forEach(function (category) {
                vm.categoryGroups[category.key].count = 0;
            });
            vm.loadingSelection = false;
        }

        vm.unselectAllFromPage = function () {
            vm.flyersFiltered.forEach(function (flyer) {
                var key = getFlyerKey(flyer);
                if (vm.selectedVisualKeys && vm.selectedVisualKeys[key]) {
                    vm.brandGroups[flyer.brand].count--;
                    vm.categoryGroups[flyer.categoryKey].count--;
                    flyer.isSelected = false;
                    delete vm.selectedVisualKeys[key];
                }
            });
            updateSelectedFlyersFromVisualKeys();
            vm.loadingSelection = false;
        }

        vm.publishFlyers = function () {
            vm.loadingActionRequest = true;
            ShowcasesService.addPublishedFlyers(vm.selectedFlyers).then(function () {
                vm.selectedFlyers.forEach(function (flyerId) {
                    addFlyerPublished(flyerId);
                    vm.loadingActionRequest = false;
                });
                vm.unselectAll();
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.publishFlyers.error"));
            });
        }

        vm.unpublishFlyers = function () {
            vm.loadingActionRequest = true;
            ShowcasesService.deletePublishedFlyers(vm.selectedFlyers).then(function () {
                vm.selectedFlyers.forEach(function (flyerId) {
                    removeFlyerPublished(flyerId);
                });
                vm.loadingActionRequest = false;
                vm.unselectAll();
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.unpublishFlyers.error"));
            });
        }

        vm.clearStock = function () {
            vm.loadingActionRequest = true;
            FlyersService.clearFlyersStock(vm.selectedFlyers).then(function () {
                loadFlyers();
                vm.unselectAll();
                vm.loadingActionRequest = false;
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.clearStock.error"));
            });
        }

        vm.checkStoreIsSelected = function (id) {
            return vm.storesSelected.includes(id);
        }

        vm.changeStoreSelected = function (stores) {
            if (Array.isArray(stores)) {
                stores.forEach(function (store) {
                    if (vm.checkStoreIsSelected(store.storeId)) {
                        vm.storesSelected = vm.storesSelected.filter(function (id) {
                            return store.storeId !== id;
                        });
                    } else {
                        vm.storesSelected.push(store.storeId);
                    }
                });
            } else {
                if (vm.checkStoreIsSelected(stores.storeId)) {
                    vm.storesSelected = vm.storesSelected.filter(function (id) {
                        return stores.storeId !== id;
                    });
                } else {
                    vm.storesSelected.push(stores.storeId);
                }
            }
        }

        vm.syncronizeProductsWithHub = function (params) {
            if (!vm.selectedFlyers) {
                return;
            }

            FlyersService.syncFlyersWithHub(vm.selectedFlyers, params).then(function () {
                vm.unselectAll();
                vm.loadingActionRequest = false;
                toastr.success($translate.instant("flyers.messages.syncFlyersWithHub.success"));
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.syncFlyersWithHub.error"));
            });
        }

        vm.syncronizeProducts = function () {
            if (!vm.selectedFlyers) {
                return;
            }

            if (vm.selectedFlyers.length > 100) {
                toastr.error($translate.instant("flyers.messages.syncErp.hundred-error"));
                return;
            }

            if (!vm.configuration || !vm.configuration.id || !vm.configuration.partnerId) {
                toastr.error($translate.instant("flyers.messages.syncErp.configuration-error"));
                return;
            }

            switch (vm.configuration.partnerId) {
                case Constants.ErpPartnerId.VAREJO_ONLINE:
                    synchronizeProductsWithVarejoOnline();
                    break;
                case Constants.ErpPartnerId.NEXAAS:
                    synchronizeProductsWithNexaas();
                    break;
                case Constants.ErpPartnerId.BLING:
                    synchronizeProductsWithBling();
                    break;
                default:
                    console.log("Sincronização de produtos indisponível com parceiro " + vm.configuration.partnerId);
            }
        }

        function synchronizeProductsWithVarejoOnline() {
            vm.removalLoading = true;
            vm.loadingActionRequest = true;
            OnlineRetailService.syncProductsByStoreAndFlyerIds($localStorage.defaultStore.storeId, vm.selectedFlyers)
                .then(function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.syncErp.success'));
                    vm.unselectAll();
                    loadFlyers();
                }, function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.error($translate.instant("flyers.messages.syncErp.general-error"));
                });
        }

        function synchronizeProductsWithNexaas() {
            vm.removalLoading = true;
            vm.loadingActionRequest = true;
            NexaasService.syncProductsByStoreAndFlyerIds($localStorage.defaultStore.storeId, vm.selectedFlyers)
                .then(function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.syncErp.success'));
                    vm.unselectAll();
                    loadFlyers();
                }, function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.error($translate.instant("flyers.messages.syncErp.general-error"));
                });
        }

        vm.onGroupByColorChange = function () {
            $localStorage[groupByColorLocalStorageKey] = vm.groupByColor;
            vm.currentPage = 1;
            loadFlyers();
        }

        function synchronizeProductsWithBling() {
            vm.removalLoading = true;
            vm.loadingActionRequest = true;
            BlingService.syncProductsByStoreAndFlyerIds($localStorage.defaultStore.storeId, vm.selectedFlyers)
                .then(function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.syncErp.success'));
                    vm.unselectAll();
                    loadFlyers();
                }, function () {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.error($translate.instant("flyers.messages.syncErp.general-error"));
                });
        }

        function applyDiscounts(discountApplied) {
            vm.loadingActionRequest = true;
            FlyersService.applyDiscountsForFlyers(vm.selectedFlyers, discountApplied).then(function () {
                loadFlyers();
                vm.unselectAll();
                vm.loadingActionRequest = false;
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.applyDiscounts.error"));
            });
        }

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;

            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalFlyers);
        }

        vm.onChangeItemsPerPage = function (newValue) {
            clearPaginationInfo();
            vm.numPerPage = newValue;
            vm.changePage();
        };

        vm.loadFilter = function (filterType, listKey, singleKey, valueKey) {
            if (vm.filters[filterType].length > 0) {
                var formatedList = vm.filters[filterType].map(function (item) {
                    return item[valueKey];
                });

                vm.listFilter[listKey] = formatedList;

                if (singleKey && formatedList.length > 0) {
                    vm.listFilter[singleKey] = formatedList[0];
                }
            } else {
                delete vm.listFilter[listKey];
                if (singleKey) {
                    delete vm.listFilter[singleKey];
                }
            }
            clearPaginationInfo();
            loadFlyers();
        };

        vm.loadFilterRange = function () {
            if (vm.filters.minValue && vm.filters.maxValue) {
                vm.listFilter.minValue = vm.filters.minValue;
                vm.listFilter.maxValue = vm.filters.maxValue;
            } else {
                delete vm.listFilter.minValue;
                delete vm.listFilter.maxValue;
            }
            clearPaginationInfo();
            loadFlyers();
        }

        function getFiltersNumber() {
            vm.numberFilterSelected =
                (angular.isArray(vm.filters.categories) ? vm.filters.categories.length : 0) +
                (angular.isArray(vm.filters.brands) ? vm.filters.brands.length : 0) +
                (angular.isArray(vm.filters.region) ? vm.filters.region.length : 0) +
                (angular.isArray(vm.filters.colors) ? vm.filters.colors.length : 0) +
                (angular.isArray(vm.filters.sizes) ? vm.filters.sizes.length : 0) +
                (angular.isArray(vm.filters.genders) ? vm.filters.genders.length : 0) +
                (vm.filters.imageOptions ? 1 : 0) +
                (angular.isArray(vm.filters.configurations) ? vm.filters.configurations.length : 0) +
                (angular.isArray(vm.filters.bedrooms) ? vm.filters.bedrooms.length : 0) +
                (angular.isArray(vm.filters.parkingSpots) ? vm.filters.parkingSpots.length : 0) +
                (angular.isArray(vm.filters.bathrooms) ? vm.filters.bathrooms.length : 0) +
                (vm.filters.minValue && vm.filters.maxValue ? 1 : 0) +
                (vm.filters.minMeters && vm.filters.maxMeters ? 1 : 0) +
                (vm.filters.sinceDate && vm.filters.untilDate ? 1 : 0) +
                (vm.filters.hubSyncFilter && (typeof vm.filters.hubSyncFilter === 'string' || (angular.isObject(vm.filters.hubSyncFilter) && vm.filters.hubSyncFilter.value !== undefined)) ? 1 : 0);
        }

        function loadFlyers() {
            if (vm.busy) return;
            vm.busy = true;

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("launch")) {
                vm.listFilter.launch = true;
            } else {
                delete vm.listFilter.launch;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("basic")) {
                vm.listFilter.basic = true;
            } else {
                delete vm.listFilter.basic;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("delivered")) {
                vm.listFilter.delivered = true;
            } else {
                delete vm.listFilter.delivered;
            }

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (!vm.listFilter.sizes || !(vm.listFilter.sizes.length > 0)) {
                delete vm.listFilter.sizes
            }

            if (!vm.listFilter.bedrooms || !(vm.listFilter.bedrooms.length > 0)) {
                delete vm.listFilter.bedrooms
            }

            if (!vm.listFilter.bathrooms || !(vm.listFilter.bathrooms.length > 0)) {
                delete vm.listFilter.bathrooms
            }

            if (!vm.listFilter.parkingSpots || !(vm.listFilter.parkingSpots.length > 0)) {
                delete vm.listFilter.parkingSpots
            }

            if (!vm.listFilter.genders || !(vm.listFilter.genders.length > 0)) {
                delete vm.listFilter.genders
            }

            if (!vm.listFilter.minValue || vm.listFilter.minValue === '') {
                delete vm.listFilter.minValue
            }

            if (!vm.listFilter.maxValue || vm.listFilter.maxValue === '') {
                delete vm.listFilter.maxValue
            }

            if (!vm.listFilter.minMeters || vm.listFilter.minMeters === '') {
                delete vm.listFilter.minMeters
            }

            if (!vm.listFilter.maxMeters || vm.listFilter.maxMeters === '') {
                delete vm.listFilter.maxMeters
            }

            if (!vm.listFilter.sinceDate) {
                delete vm.listFilter.sinceDate
            }

            if (!vm.listFilter.untilDate) {
                delete vm.listFilter.untilDate
            }

            if (!vm.listFilter.region || !(vm.listFilter.region.length > 0)) {
                delete vm.listFilter.region
            }

            if (!vm.filters.categories || !(vm.filters.categories.length > 0)) {
                delete vm.listFilter.categoryKeys;
                delete vm.listFilter.categoryKey;
            }

            if (!vm.filters.brands || !(vm.filters.brands.length > 0)) {
                delete vm.listFilter.brand;
                delete vm.listFilter.brands;
            }

            if (!vm.listFilter.hubSyncFilter) {
                delete vm.listFilter.hubSyncFilter;
            }

            if (vm.selectedSortByOption.value === 'inventory') {
                vm.listFilter.hasInventory = false;
            }

            getEmptyMessage()

            getFiltersNumber()

            FlyersService.listAllToAdmin(vm.paginationOptions, vm.listFilter, vm.groupByColor, onSuccess, onError);

            function onSuccess(data, headers) {

                vm.zeroOffers = data.content.length <= 0;
                vm.flyersFiltered = data.content;

                if (vm.zeroOffers) {
                    vm.flyersFiltered = [];
                    vm.selectedAll = false;
                } else {
                    vm.selectedAll = true;
                    vm.selectedVisualKeys = vm.selectedVisualKeys || {};

                    angular.forEach(vm.flyersFiltered, function (flyer) {
                        var isSelected = vm.selectedFlyers.some(function(selectedId) {
                            return selectedId == flyer.id;
                        });

                        flyer.isSelected = isSelected;
                        if (flyer.isSelected) {
                            var key = getFlyerKey(flyer);
                            vm.selectedVisualKeys[key] = true;
                        } else {
                            vm.selectedAll = false;
                        }
                    })
                }

                var storeCurrency = loadCurrencyPrefix(vm.store);
                vm.flyersFiltered = vm.flyersFiltered.map(function (flyer) {
                    vm.getCategoryName(flyer);
                    flyer.currencyInstance = storeCurrency;
                    return flyer;
                });

                vm.totalFlyers = headers('X-Total-Count');
                vm.changePage();

                vm.isLoading = false;
                vm.busy = false;

                var listFilterCopy = angular.copy(vm.listFilter)

                delete listFilterCopy.storeId
                delete listFilterCopy.text

                $localStorage[listFilterLocalStorageKey] = listFilterCopy;
                $localStorage[filterLocalStorageKey] = vm.filters;
            }

            function onError(_) {
                vm.busy = false;
                vm.isLoading = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        function getEmptyMessage() {
            if (vm.listFilter.text && vm.listFilter.text.length > 0) {
                vm.emptyTitle = vm.getTranslateKey('flyers.new.error.notFound');
                vm.emptyDescription = "";
            } else {
                vm.emptyTitle = vm.getTranslateKey('flyers.home.empty.title');
                vm.emptyDescription = vm.getTranslateKey('flyers.home.empty.description');
            }
        }


        function checkForCurrentBrand(brands) {
            var result = false;
            brands.forEach(function (brand) {
                if (brand.name == vm.listFilter.brand)
                    result = true;
            });
            return result;
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(
                function (response) {
                    if (response && response.data) {
                        vm.store = response.data;
                        loadShowcaseSettings();
                    }
                }
            );
        }

        function loadShowcaseSettings() {
            ShowcaseSettingsService.getByStoreId($localStorage.defaultStore.storeId).then(function (settings) {
                if (settings  && settings.data) {
                    vm.store.groupByColorEnabled = settings.data.groupByColorEnabled;
                    if (!vm.store.groupByColorEnabled) {
                        vm.groupByColor = false;
                        $localStorage[groupByColorLocalStorageKey] = false;
                    }
                }
            });
        }

        function loadCurrencyPrefix(store) {
            var storeCurrency = store.currency ? store.currency : "REAL";
            return getCurrencyListConfiguration()[storeCurrency];
        }

        function updateIsMobile() {
            var previousValue = vm.isMobile;
            vm.isMobile = $window.innerWidth <= 768;

            if (previousValue !== vm.isMobile) {
                initializeActionsOptions();
                if (vm.isMobile) {
                    vm.isListView = true
                    $localStorage[isListViewLocalStorageKey] = vm.isListView;
                }
            }
        }

        function loadBrands() {
            BrandService.getBrandsByCurrentStore().then(function (response) {
                vm.brands = response.data;
                if (!checkForCurrentBrand(response.data))
                    vm.listFilter.brand = response.data[0].name;
                vm.brands = _.uniqBy(vm.brands, 'name');
                sortBrandsByName();
                vm.brands.forEach(function (brand) {
                    vm.brandGroups[brand.name] = {
                        count: 0,
                        total: brand.quantFlyer
                    };
                });
                loadFlyers();
            });
        }

        vm.showModalBrand = function showModalBrand() {
            ModalBrandFactory.listModal().then(function (_) {
                loadBrands();
            });
        }

        vm.checkFlyerIsPublished = function (flyer) {
            if (flyer !== undefined && vm.publishedProducts) {
                return vm.publishedProducts.includes(flyer.id);
            }
        };


        function removeFlyerPublished(flyerId) {
            vm.publishedProducts = vm.publishedProducts.filter(function (id) {
                return flyerId !== id;
            });
        }

        function addFlyerPublished(flyerId) {
            vm.publishedProducts.push(flyerId)
        }

        vm.unpublishFlyer = function (flyerId) {
            ShowcasesService.deletePublishedFlyer(flyerId).then(function (data) {
                removeFlyerPublished(flyerId);
            }, function () {
            });
        }

        vm.publishFlyer = function (flyerId) {
            ShowcasesService.addPublishedFlyer(flyerId).then(function (data) {
                addFlyerPublished(flyerId);
            }, function (response) {
                if (response.status === 404 || response.status === 400) {
                    toastr.warning($translate.instant('flyers.messages.published.warning'));
                } else {
                    toastr.error($translate.instant("flyers.messages.published.error"));
                }
            });
        }

        function getConfigurationsValues() {
            vm.configurations = [
                {id: 1, label: "flyers.new.form.configurations.launch", code: "launch"},
                {id: 2, label: vm.getTranslateKey('flyers.new.form.configurations.basic'), code: "basic"}
            ];

            if (vm.isImmoContext) {
                vm.configurations.push(
                    {id: 3, label: "flyers.new.form.configurations.delivered", code: "delivered"}
                );
            }
        }

        vm.bedrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.parkingSpots = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.bathrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.openFiltersModal = function () {
            var filtersModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                categories: vm.categories,
                                brands: vm.brands,
                                colors: vm.colors,
                                sizes: vm.sizes,
                                bedrooms: vm.bedrooms,
                                bathrooms: vm.bathrooms,
                                parkingSpots: vm.parkingSpots,
                                configurations: vm.configurations,
                                clearFilters: vm.clearFilters,
                                itemsPerPageOptions: vm.itemsPerPageOptions,
                                sortOptions: vm.sortOptions,
                                numPerPage: vm.numPerPage,
                                selectedSort: vm.selectedSortByOption,
                                groupByColor: vm.groupByColor,
                                groupByColorEnabled: vm.store.groupByColorEnabled,
                                showHubSyncFilter: true
                            },
                            filters: vm.filters,
                            list: vm.listFilter,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.FILTERS
                        }
                    }
                },
            });
            var unbindRouteChange = $rootScope.$on('$locationChangeStart', function() {
                filtersModal.dismiss('route change');
            });

            filtersModal.result.then(function (response) {
                vm.unselectAll();
                if (response) {
                    vm.filters = response.selectedFilters;
                    if (vm.numberFilterSelected === 0) {
                        loadBrandsAndCategories();
                    } else
                        vm.listFilter = response.listFilter;

                    if (response.numPerPage && response.numPerPage !== vm.numPerPage) {
                        vm.numPerPage = response.numPerPage;
                    }
                    clearPaginationInfo();

                    if (response.sortSelected && response.sortSelected !== vm.selectedSortByOption) {
                        vm.selectedSortByOption = response.sortSelected;
                        vm.listFilter.sortBy = vm.selectedSortByOption.value;
                        vm.listFilter.sortBy = vm.selectedSortByOption.value;
                        vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
                    }

                    if (response.groupByColor !== undefined && response.groupByColor !== vm.groupByColor) {
                        vm.groupByColor = response.groupByColor;
                        $localStorage[groupByColorLocalStorageKey] = vm.groupByColor;
                        vm.currentPage = 1;
                    }

                    loadFlyers();
                }
                unbindRouteChange();
            }, function () {
                unbindRouteChange();
            });
        }

        vm.clearFilters = function () {
            vm.unselectAll();

            // Limpa os filtros do vm.filters
            vm.filters = {
                region: [],
                categories: [],
                brands: [],
                colors: [],
                sizes: [],
                genders: [],
                bedrooms: [],
                bathrooms: [],
                parkingSpots: [],
                configurations: [],
                hasInventory: false,
                hubSyncFilter: null,
                minValue: null,
                maxValue: null,
                minMeters: null,
                maxMeters: null,
                sinceDate: null,
                untilDate: null,
                tags: [],
                sortSelected: {
                    value: 'lastModifiedDate',
                    direction: 'desc',
                },
            };

            // Reseta o vm.listFilter para o estado inicial
            vm.listFilter = {
                activated: null,
                hasInventory: false,
                storeId: $localStorage.defaultStore.storeId,
                sortBy: 'lastModifiedDate',
                sortDirection: 'desc',
            };

            delete vm.listFilter.sinceDate;
            delete vm.listFilter.untilDate;


            // Atualiza o localStorage
            $localStorage[listFilterLocalStorageKey] = angular.copy(
                vm.listFilter
            );
            $localStorage[filterLocalStorageKey] = angular.copy(vm.filters);

            clearPaginationInfo();
            loadFlyers();
        };


        function getFlyerUrl(flyer) {
            var url = flyer.flyerUrl;
            if (flyer.groupingColorId) {
                url += (url.indexOf('?') === -1 ? '?' : '&') + 'color=' + flyer.groupingColorId;
            }
            return url;
        }

        function accessHotsite(flyer) {
            var url = getFlyerUrl(flyer);
            if ($localStorage.defaultStore.storeInfo.redirectUrl) {
                const newDomain = replaceDomain(url,$localStorage.defaultStore.storeInfo.redirectUrl);
                window.open(newDomain);
            } else {
                window.open(url, '_blank');
            }
        }

        function copyLink(flyer) {
            var url = getFlyerUrl(flyer);
            if ($localStorage.defaultStore.storeInfo.redirectUrl) {
                const newDomain = replaceDomain(url,$localStorage.defaultStore.storeInfo.redirectUrl);
                copyToClipboard(newDomain).then(function () {
                    toastr.success($translate.instant('flyers.card.messages.link'));
                });
            } else {
                copyToClipboard(url).then(function () {
                    toastr.success($translate.instant('flyers.card.messages.link'));
                });
            }
        }

        function shareWhatsapp(flyer) {
            var url = getFlyerUrl(flyer);
            var message = $translate.instant('flyers.card.messages.whatsapp-product') + ' ' + url;
            var whatsappUrl = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);

            if ($localStorage.defaultStore.storeInfo.redirectUrl) {
                const newDomain = replaceDomain(url,$localStorage.defaultStore.storeInfo.redirectUrl);
                message = $translate.instant('flyers.card.messages.whatsapp-product') + ' ' + newDomain;
                whatsappUrl = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);
                window.open(whatsappUrl, '_blank');
            } else {
                window.open(whatsappUrl, '_blank');
            }
        }

        vm.withoutStockTooltip = function (item) {
            return item.inventory <= 0 && item.inventory != null ? $translate.instant('flyers.offerList.without-stock') : ''
        }

        vm.unlimitedStock = function (item) {
            return item.inventory != null ? item.inventory : $translate.instant('flyers.offerList.unlimited-stock');
        }

        function configureFlyerMethods() {
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.HOTSITE,
                function (flyer) {
                    accessHotsite(flyer);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.LINK, function (flyer) {
                    copyLink(flyer);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.SEND,
                function (flyer) {
                    shareWhatsapp(flyer);
                });
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.EDIT,
                function (flyer) {
                    $state.go('flyers.edit', {
                        id: flyer.id
                    });
                    var closeModal = vm.flyerMethods.get(flyersConstants.FLYER_ACTION.CLOSE_DETAILS_MODAL);
                    if (typeof closeModal === 'function') {
                        closeModal(flyersConstants.FLYER_ACTION.EDIT);
                    }
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.DELETE,
                function (flyer) {
                    vm.singleFlyerToDelete = flyer.id
                    vm.verifyIfFlyersIsPublished();
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.DUPLICATE,
                function (flyer) {
                    // TODO: implementar duplicação
                    console.log(flyersConstants.FLYER_ACTION.DUPLICATE + ': ' + flyer.id);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.RECOMMEND,
                function (flyer) {
                    // TODO: implementar ou remover recomendação
                    console.log(flyersConstants.FLYER_ACTION.RECOMMEND + ': ' + flyer.id);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.PUBLISH,
                function (flyer) {
                    vm.publishFlyer(flyer.id);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.UNPUBLISH,
                function (flyer) {
                    vm.unpublishFlyer(flyer.id);
                }
            );
        }

        function getSortOptions(locale) {
            if (vm.isImmoContext) {
                return paginationConstants.immoSortOptions[locale];
            }

            if (vm.groupByColor) {
                return paginationConstants.groupByColorSortOptions[locale];
            } else {
                return paginationConstants.sortOptions[locale];
            }
        }
    }

})();
